export default {
  title: 'Parameters & Query Flow',
  img: 'flow',
  subsections: [
    {
      title: 'Query Parameters',
      content: [
        {
          tag: 'p',
          content: `In order to make the most accurate and concise requests to the BreeziPro API, a variety of Query Parameters are
          applicable to several of the services, which will allow users to specify attributes such as timestamp, alert threshold
          and reading type in each request. While many of these parameters are compatible with multiple services, each service’s Query
          Parameters are outlined in the <b>Services</b> section of this documentation. Query Parameters are expressed as key/value pairs
          within the request url. The first parameter is denoted by a question mark (?), with an equal sign (=) between the key and the
          value. So that multiple parameters can be included in a single request, each subsequent key/value pair will be separated from
          the previous using an ampersand (&). Therefore an example request url using Query Parameters would look like this:`
        },
        {
          tag: 'ul',
          content: ['<b>https://api-pro.breezi.net/measurements/AP000000?from=3141592653589&to=3141592653590</b>']
        },
        {
          tag: 'p',
          content: `Please Note: Timestamp ranges are to be expressed in UNIX Epoch time (seconds). For more information on UNIX time, visit <a href="https://www.epoch101.com/">this link</a>. Please do not use commas in Query String timestamps for requests to the BreeziPro Commercial API.`
        }
      ]
    },
    {
      title: 'Account Data Query Flow',
      content: [
        {
          tag: 'png',
          content: 'accountFlow'
        },
        {
          tag: 'ol',
          content: [
            `The user invokes <b>Auth</b> Service via a POST request to {api-url}/auth, with a body in JSON format, where email and password are the same as those used to log into the PWA.`,
            `Auth service returns a response in JSON format, containing basic information in regards to user’s Organization, as well as the API key needed to make further calls and track API usage.`,
            `User invokes <b>Account</b> service via a GET request to {api-url}/account, with the API Key set as the request x-api-key header.`,
            `<b>Account</b> service returns a response in JSON format which includes information about the organization’s API plan and usage, including Capacity Units consumed and Calls Made to API in the current billing cycle. Unique ids used to query each building included on your Organization’s account will also be dispensed from this service, which will serve as the requisite path parameter for subsequent queries. Please see the “Parameters” section of this documentation to learn how ids are used to return pertinent and accurate datasets.`
          ]
        }
      ]
    },
    {
      title: 'Snapshot Data Flow',
      content: [
        {
          tag: 'png',
          content: 'snapshotFlow'
        },
        {
          tag: 'ol',
          content: [
            `The user invokes the <b>Account</b> Service via a GET request to {api-url}/account, with the Organization’s API Key included in the x-api-key request header.`,
            `The <b>Account</b> service returns a list of unique building ids, and the serial numbers of each AirPulse installed within said building.`,
            `The user makes a GET request to snapshot/{entityId}, where {entityId} is either the building id or AirPulse serial number.`,
            `The <b>Snapshot</b> service validates ownership of the device, and returns a response in JSON format with the most recent measurements recorded by either the requested AirPulse device (Using AP Serial Number) or the requested Building (using Building Unique Id).`
          ]
        }
      ]
    },
    {
      title: 'Alerts/Measurement Data Flow',
      content: [
        {
          tag: 'png',
          content: 'alertsFlow'
        },
        {
          tag: 'ol',
          content: [
            `The user invokes the <b>Alerts</b> API service by sending a GET request to https://api-pro.breezi.net/alerts/{airpulseSerialNumber}, where {airpulseSerialNumber} has been returned from a prior query to the <b>Account</b> service`,
            `The <b>Alerts</b> service returns a range of timestamps during which the requested AirPulse emitted a measurement which has crossed an alert threshold, defined either by the Organization’s custom Setpoint (can be adjusted in the PWA), or by Breezi’s default Setpoints, outlined later in this documentation.`,
            `The user configures a query to the <b>Measurements</b> service and sends a GET request to https://{api-url}/{serialNumber}?from={alertStartTimestamp}&to={alertEndTimestamp}, where the alert timestamps correspond to a fluctuation in alert status as outlined by the response from the <b>Alerts</b> Service.`,
            `The <b>Measurements</b> service returns a series of measurement points which fall between the requested timestamp parameters, allowing for a closer look at the conditions which were present during the time the alert threshold was exceeded.`
          ]
        },
        {
          tag: 'p',
          content: `Please note: This is not the only method of using these API services. They can also be used independent of one another, and
          historical measurements can be requested without the need for a timestamp range. For more information on the capabilities of both
          services, please see the <b>Alerts Service</b> and <b>Measurements Service</b> sections later in this documentation.`
        }
      ]
    }
  ]
}

function colorfyURL(url){
  let base = '<b><span style="color:rgb(80, 142, 68)">https://api-pro.breezi.net</span>'
  url = url.replace('https://api-pro.breezi.net', '');
  if (url.length) {
    let pparams = url.split('/');
    let qparams = '';
    let lparam = pparams[pparams.length - 1];
    if (lparam.includes('?')) {
      let qp = lparam.split('?');
      lparam = lparam.replace('?' + qp, '');
      // qparams = qp.includes('&') ? '?' + qp.split('&').map(q => `<span style="color:purple">${q}</span>`).join('&') : `<span style="color:purple">${qp}</span>`;
    }
    base += pparams.map(p => `<span style="color:rgb(194, 139, 17)">${p}</span>`).join('/') + qparams;
  }
  base += '</b>';
  return base;
}



// WEBPACK FOOTER //
// ./src/lib/apiDocTemplates/parameters.js